/**
 * @internal
 */
export var getDiscountedPrice = function (price) {
    if (!price) {
        return;
    }
    return price.discountedPrice
        || price.c_discountedPrice
        || price.fromDiscountedPrice;
};
